import config from 'coeus.config';

export const AdminCards = [
    {
        roles: ['User', 'Admin', 'OrgAdmin'],
        title: 'Dashboard',
        description: 'Go to dashboard to start exploring new insights.',
        icon: 'Dashboard',
        url: '/',
        active: true,
    },
    {
        roles: ['User', 'Admin', 'OrgAdmin'],
        title: 'Manage Account',
        description:
            'View and update your account details, and profile settings.',
        icon: 'AccountBox',
        url: '/profile',
        active: true,
    },
    {
        roles: ['Admin', 'OrgAdmin'],
        title: 'Manage Users',
        description:
            'Invite your team members to dashboard and work with your data together.',
        icon: 'PeopleOutline',
        url: '/settings/users',
        active: true,
    },
    {
        roles: ['Admin'],
        title: 'Manage Content',
        icon: 'Pages',
        description:
            'Create, update and delete pages of the mashup application, add and remove objects from pages existing in the dashboard.',
        url: '/settings/pages',
        active: true,
    },
    {
        roles: ['Admin'],
        title: 'Manage Site Licence',
        icon: 'VpnKey',
        description: 'Add and update your COEUS site licence.',
        url: '/settings/site-licence',
        active: true,
    },
    {
        roles: ['Admin'],
        title: 'Manage Security Groups',
        icon: 'GroupWork',
        description:
            'Create, update and delete groups for pages, objects and users. Access to pages and objects can be restricted through groups.',
        url: '/settings/groups',
        active: true,
    },
    {
        roles: ['Admin'],
        title: 'Manage Appearance',
        icon: 'ColorLens',
        description: 'Change the default COEUS portal colour scheme.',
        url: '/settings/theme',
        active: false,
    },
    {
        roles: ['Admin'],
        title: 'Manage Qlik Sense Server',
        icon: 'Dns',
        description:
            'Setup the Qlik Sense Host to define Qlik engine connection and Qlik Sense client side software and extensions location.',
        url: '/settings/qsserver',
        active: true,
    },
    {
        roles: ['Admin'],
        title: 'Manage Email Server',
        icon: 'MailOutline',
        description:
            'Setup email SMTP details to enable outgoing emails from the portal.',
        url: '/settings/smtp',
        active: false,
    },
    {
        roles: ['Admin'],
        title: 'Manage ADAG',
        icon: 'DynamicFeed',
        description:
            'Configure dynamic application generation filters, values and master applications.',
        url: '/settings/dag',
        active: false,
    },
    {
        roles: ['Admin'],
        title: 'Manage Auth Alerts',
        icon: 'Announcement',
        description:
            'Configure Auth Alert, create an alert that will be presented to users when they login',
        url: '/settings/auth-alert',
        active: true,
    },
];

const AdminMenuGroups = [
    {
        group: 'SETTINGS',
        key: 'g1',
        roles: [],
        active: true,
        menuItems: [
            {
                key: 'g1-m1',
                title: 'Settings Home',
                icon: 'Settings',
                url: '/settings',
                roles: ['User', 'Admin', 'OrgAdmin'],
            },
            {
                key: 'g1-m2',
                title: 'Help',
                icon: 'HelpOutline',
                url: '/settings/help',
                roles: ['User', 'Admin', 'OrgAdmin'],
            },
            {
                key: 'g1-m3',
                title: 'My Account',
                icon: 'AccountBox',
                url: '/profile',
                roles: ['User', 'OrgAdmin', 'Admin'],
            },
        ],
    },
    {
        group: 'Organisation',
        key: 'g2',
        active: false,
        roles: ['OrgAdmin', 'Admin'],
        menuItems: [
            {
                title: 'Organisations',
                key: 'g2-m1',
                icon: 'Business',
                url: '/settings/organisations',
                roles: ['Admin'],
            },
            {
                title: 'Subscriptions',
                key: 'g2-m3',
                icon: 'CardMembership',
                url: '/settings/subscription',
                roles: ['Admin', 'OrgAdmin'],
            },
        ],
    },
    {
        group: 'MANAGE RESOURCES',
        key: 'g3',
        active: true,
        roles: ['Admin'],
        menuItems: [
            {
                title: 'Users',
                key: 'g3-m2',
                icon: 'PeopleOutline',
                url: '/settings/users',
                submenu: [
                    {
                        title: 'All Users',
                        url: '/settings/users',
                        key: 'g2-m2-s1',
                    },
                    {
                        title: 'Create User',
                        url: '/settings/users/create',
                        key: 'g2-m2-s2',
                    },
                ],
                roles: ['User', 'Admin', 'OrgAdmin'],
            },
            {
                title: 'Content',
                key: 'g3-m1',
                icon: 'Pages',
                url: '/settings/pages',
                submenu: [
                    {
                        title: 'All Pages',
                        url: '/settings/pages',
                        key: 'g3-m1-s1',
                    },
                    {
                        title: 'Create Page',
                        url: '/settings/pages/create',
                        key: 'g3-m1-s2',
                    },
                ],
                roles: ['Admin'],
            },
        ],
    },
    {
        group: 'CONFIGURE SYSTEM',
        key: 'g4',
        active: true,
        roles: ['Admin'],
        menuItems: [
            // {
            //   title: 'Pricing',
            //   key: 'g4-m2',
            //   icon: 'LocalOffer',
            //   url: '/settings/pricing',
            //   submenu: [
            //     { title: 'Price List', url: '/settings/pricing', key: 'g3-m2-s1' },
            //     { title: 'New Price', url: '/settings/pricing/create', key: 'g3-m2-s2' },
            //   ],
            //   roles: ['Admin'],
            // },
            {
                title: 'Security Groups',
                key: 'g4-m3',
                icon: 'GroupWork',
                url: '/settings/groups',
                submenu: [
                    {
                        title: 'All Groups',
                        key: 'g3-m3-s1',
                        url: '/settings/groups',
                    },
                    {
                        title: 'Create Group',
                        key: 'g3-m3-s2',
                        url: '/settings/groups/create',
                    },
                ],
                roles: ['Admin'],
            },
            {
                title: 'Site Licence',
                key: 'g4-m4',
                icon: 'VpnKey',
                url: '/settings/site-licence',
                roles: ['Admin'],
            },
            {
                title: 'Qlik Sense Server',
                key: 'g4-m5',
                icon: 'Dns',
                url: '/settings/qsserver',
                roles: ['Admin'],
            } /*
      {
        title: 'Email Server',
        key: 'g4-m6',
        icon: 'MailOutline',
        url: '/settings/smtp',
        roles: ['Admin'],
      },*/,
            {
                title: 'Appearance',
                key: 'g4-m7',
                icon: 'ColorLens',
                url: '/settings/theme',
                roles: ['Admin'],
            },
            {
                title: 'Auth Alert',
                key: 'g4-m8',
                icon: 'Announcement',
                url: '/settings/auth-alert',
                roles: ['Admin'],
            },
            {
                title: 'API Key',
                key: 'g4-m9',
                icon: 'VpnKey',
                url: '/settings/api-key',
                roles: ['Admin'],
            },
        ],
    },
];

const adagMenuGroup = {
    group: 'ADAG',
    key: 'g4-m9',
    active: true,
    roles: ['Admin'],
    menuItems: [
        {
            key: 'g4-m8-i1',
            title: 'Master Apps',
            icon: 'Apps',
            url: '/settings/dag/master-apps',
            submenu: [
                {
                    title: 'All Master Apps',
                    url: '/settings/dag/master-apps',
                },
                {
                    title: 'Create Master App',
                    url: '/settings/dag/master-apps/create',
                },
            ],
            roles: ['Admin'],
        },
        {
            key: 'g4-m8-i2',
            title: 'Filters',
            icon: 'FilterList',
            url: '/settings/dag/filters',
            submenu: [
                { title: 'All Filters', url: '/settings/dag/filters' },
                {
                    title: 'Create Filter',
                    url: '/settings/dag/filters/create',
                },
            ],
            roles: ['Admin'],
        },
        {
            key: 'g4-m8-i3',
            title: 'Dynamic Apps',
            icon: 'DynamicFeed',
            url: '/settings/dag/dynamic-apps',
            roles: ['Admin'],
        },
    ],
};

export const getAdminMenuGroups = () => {
    const facilityItem = {
        group: 'FACILITIES',
        key: 'g2.3',
        active: true,
        roles: ['Admin', 'User'],
        menuItems: [
            {
                title: 'File Upload',
                key: 'g2.3-m1',
                icon: 'CloudUpload',
                url: '/facilities/file-upload',
                roles: ['Admin', 'User'],
            },
        ],
    };

    const routes = AdminMenuGroups;

    if (config.feature.upload_manager.enabled) {
        routes.splice(2, 0, facilityItem);
    }

    if (config.feature.adag.enabled) {
        routes.push(adagMenuGroup);
    }

    return routes;
};
